<template>
  <div class="">
    <v-list v-if="nested_items">
      <template v-for="(item, index) in nested_items">
        <v-subheader v-if="item.header" :key="item.header" class="green--text">
          <v-icon v-if="header_icon" large class="green--text pl-3">{{
            header_icon
          }}</v-icon>
          {{ item.header }} :
        </v-subheader>

        <v-list-item :key="title" v-for="(title, index) in item.titles">
          <v-list-item-title class="primary--text font-weight-bold text-wrap">
            <v-icon v-if="text_icon" large>{{ title.icon }}</v-icon>
            <span v-else>{{ index + 1 }} –</span>
            {{ title }}
          </v-list-item-title>
        </v-list-item>
        <v-divider v-if="item.divider" :key="index"></v-divider>
      </template>
    </v-list>
    <v-list v-if="index_items">
      <template v-for="(item, index) in index_items">
        <v-list-item :key="item.text">
          <v-list-item-title class="primary--text font-weight-bold text-wrap">
            <v-icon class="green--text pl-3" v-if="text_icon">{{
              text_icon
            }}</v-icon>
            <span v-else>{{ index + 1 }} –</span>
            <span>{{ item.text }}</span>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </div>
</template>

<script>
export default {
  name: "PublicList",
  props: {
    nested_items: {
      type: Array,
      default: null,
    },
    index_items: {
      type: Array,
      default: null,
    },
    header_icon: {
      type: String,
      default: null,
    },
    text_icon: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped></style>
